import React,{useState,useEffect} from 'react'
import { motion } from "framer-motion";
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { AppWrapper, MotionWrapper } from "../../wrapper";
import { urlFor, client } from "../../client";


import './testimonial.scss'

const Testimonial = () => {
  const [brands, setBrands] = useState([])
  const [testimonials, setTestimonials] = useState([])
  const [currentIndex, setCurrentIndex] = useState(0)
  const controller = new AbortController()
  useEffect(() => {
    const query = '*[_type == "testimonials"]'
    const brandsQuery = '*[_type == "brands"]'
    client.fetch(query,{ signal: controller.signal })
    .then((data)=> {
      setTestimonials(data)
    })
    client.fetch(brandsQuery,{ signal: controller.signal })
    .then((data)=> {
      setBrands(data)
    })
    return () =>{
      controller.abort()
    }
    }, [])
    const test = testimonials[currentIndex]
    const handleClick = (index)=>{
      setCurrentIndex(index)
    }
  return (
    <>
      {testimonials.length && (
        <>
        <div className='app__testimonial-item app__flex'>
          <img src={urlFor(test.imgUrl)} alt="testimonials" />
          <div className='app__testimonial-content'>
            <p className='p-text'>{test.feedback}</p>
            <h4 className='bold-text'>{test.name}</h4>
          <h5 className='p-text'>{test.company}</h5>
          </div>
        </div>
        <div className='app__testimonial-btns app__flex'>
          <div className='app__flex' onClick={()=> handleClick(currentIndex===0 ? testimonials.length-1 :  currentIndex-1)}>
            <HiChevronLeft/>
          </div>
          <div className='app__flex' onClick={()=> handleClick(currentIndex===testimonials.length-1 ? 0 :  currentIndex+1)}>
            <HiChevronRight/>
          </div>
        </div>
        </>
      )}
    </>
  )
}

export default AppWrapper(
  MotionWrapper( Testimonial,'app__testimonial'),
  'testimonial',
  'app__primarybg'
  )

